import { render } from "./StockTakeLogView.vue?vue&type=template&id=444e7f9d"
import script from "./StockTakeLogView.vue?vue&type=script&lang=js"
export * from "./StockTakeLogView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__